import React from 'react';
import {
  Button,
  Typography,
  Grid,
  TypographyProps,
  Stack,
} from '@mui/material';
import moment from 'moment';
import { TP_COLORS } from '../../../../../constants';
import { ISubmission } from '../../../../../store/SubmissionSlice';
import {
  getOrdinalNumber,
  getUrlConvertedString,
  msToMinutesSeconds,
} from '../../../../../helper';
import { useAppSelector } from '../../../../../hooks';
import {
  getSubmissionsV2State,
  ISubTopicSubmission,
} from '../../../../../store/V2/SubmissionsSlice';
import { viewButtonProps } from '../../../QuizPerformance/DetailedOverview/components/StudentPerformanceRow';

const typoProps: TypographyProps = {
  fontSize: '14px',
  color: TP_COLORS.gray.darken,
};

const subTypoProps: TypographyProps = {
  fontSize: '12px',
  color: '#94A3B8',
};

interface ISubmissionItemProps {
  subTopicData: ISubTopicSubmission;
  index: number;
}

const SubmissionItem: React.FC<ISubmissionItemProps> = ({
  subTopicData,
  index,
}) => {
  // store
  const { groupedSubTopicsSubmissions } = useAppSelector(getSubmissionsV2State);

  const submissionData = subTopicData.submissions[index] as ISubmission;
  const submittedAt = moment(submissionData.completedAt).format(
    'YYYY-MM-DD hh:mm A'
  );
  const percentageScore = Math.round(
    (submissionData.score / submissionData.totalScore) * 20
  );

  const timeTaken = msToMinutesSeconds(
    (submissionData.timerEnd || 0) - (submissionData.timerStart || 0)
  );

  const selectedTopic = groupedSubTopicsSubmissions[0];

  const handleViewClick = () => {
    const urlConvertedCurriculum = getUrlConvertedString(
      selectedTopic.curriculum
    );
    const urlConvertedSubject = getUrlConvertedString(selectedTopic.subject);
    const urlConvertedTopic = getUrlConvertedString(selectedTopic.topicName);
    const urlConvertedSubTopic = getUrlConvertedString(
      subTopicData.subTopicName
    );

    const path = `${process.env.PUBLIC_URL}/dashboard/${urlConvertedCurriculum}/${urlConvertedSubject}/${urlConvertedTopic}/${urlConvertedSubTopic}/${subTopicData.subTopicId}/view-quiz/${submissionData._id}`;

    window.open(path, '_blank');
  };
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={3} sm={3} md={2}>
        <Typography {...typoProps}>Attempt</Typography>
        <Typography {...subTypoProps}>
          {getOrdinalNumber(index + 1)} Attempt
        </Typography>
      </Grid>

      <Grid item xs={6} sm={4} md={3}>
        <Typography {...typoProps}>Submission Date & Time</Typography>
        <Typography {...subTypoProps}>{submittedAt}</Typography>
      </Grid>

      <Grid item xs={3} sm={2} md={2}>
        <Typography {...typoProps}>Score</Typography>
        <Typography {...subTypoProps}>{percentageScore}/20</Typography>
      </Grid>

      <Grid item xs={5} sm={3} md={2}>
        <Typography {...typoProps}>Time Taken</Typography>
        <Typography {...subTypoProps}>{timeTaken}</Typography>
      </Grid>

      <Grid item xs={7} sm={12} md={3}>
        <Stack alignItems="center">
          <Button {...viewButtonProps} onClick={handleViewClick}>
            View
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SubmissionItem;
